import { Upload, Button } from "antd";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { useForm } from "react-hook-form";
import React from "react";

const TestGdsQueryPage = () => {
  const { setValue, watch, handleSubmit } = useForm({
    defaultValues: {
      file: null,
    },
  });

  const [downloadUrl, setDownloadUrl] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  // Handle file selection from Antd Upload
  const uploadProps = {
    beforeUpload: (file:any) => {
      const allowedTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv",
      ];

      if (!allowedTypes.includes(file.type)) {
        alert("Only Excel or CSV files allowed!");
        return Upload.LIST_IGNORE;
      }

      setValue("file", file); // store file in react-hook-form
      return false; // prevent auto upload
    },
  };

  const onSubmit = async () => {
    const file = watch("file");

    if (!file) {
      alert("Please upload a file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setIsLoading(true);

    try {
      const response = await fetch(
        "https://oogwai.gaggle.online/api/v1/bulk-validate-google-ads-queries",
        {
          method: "POST",
          body: formData,
        }
      );

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      setDownloadUrl(url);
    } catch (error) {
      console.error(error);
      alert("Upload failed!");
    }

    setIsLoading(false);
  };

  return (
    <div className="mt-8">
      <h2 className="text-lg font-semibold mb-4">Test GDS Query Page</h2>

      {/* ANTD Upload Button */}
      <Upload {...uploadProps} maxCount={1}>
        <Button icon={<UploadOutlined />}>Click to Upload Excel</Button>
      </Upload>

      <br />
      <br />

      {/* Upload & Validate Button */}
      <Button
        type="primary"
        loading={isLoading}
        onClick={handleSubmit(onSubmit)}
      >
        Upload & Validate
      </Button>

      {/* Download Response Button */}
      {downloadUrl && (
        <a href={downloadUrl} download="validated_result.xlsx">
          <Button
            type="default"
            className="ml-4"
            icon={<DownloadOutlined />}
          >
            Download Response
          </Button>
        </a>
      )}
    </div>
  );
};

export default TestGdsQueryPage;
